import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Button } from "../ui/button";

const ANY = "__any";
const Pick = ({ value, onChange, options, placeholder, testId, width = "sm:w-40" }) => (
  <Select value={value || ANY} onValueChange={(v) => onChange(v === ANY ? "" : v)}>
    <SelectTrigger className={`h-8 text-xs ${width}`} data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      <SelectItem value={ANY}>{placeholder}</SelectItem>
      {options.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`${testId}-${v}`}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const EMPTY_FILTERS = { agent_id: "", status: "", task_type: "", dedup: "", memory: "", scope: "", workflow_id: "", error_category: "" };

export const TaskFilters = ({ filters, onChange, agents, taskTypes, scopes }) => {
  const set = (k) => (v) => onChange({ ...filters, [k]: v });
  const active = Object.values(filters).some(Boolean);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="task-filters">
      <Pick value={filters.agent_id} onChange={set("agent_id")} placeholder="All agents" testId="filter-agent" options={Object.entries(agents || {})} />
      <Pick value={filters.status} onChange={set("status")} placeholder="Any status" testId="filter-status" width="sm:w-32" options={[["completed", "completed"], ["failed", "failed"], ["rejected", "rejected"], ["RUNNING", "RUNNING"]]} />
      <Pick value={filters.task_type} onChange={set("task_type")} placeholder="Any task type" testId="filter-task-type" width="sm:w-48" options={(taskTypes || []).map((t) => [t, t])} />
      <Pick value={filters.memory || filters.dedup} onChange={(v) => onChange({ ...filters, memory: v === "hit" || v === "miss" ? v : "", dedup: v === "collapsed" ? v : "" })} placeholder="Memory / dedup" testId="filter-memory" width="sm:w-36" options={[["hit", "memory hit"], ["collapsed", "collapsed"], ["miss", "miss"]]} />
      <Pick value={filters.scope} onChange={set("scope")} placeholder="Any scope" testId="filter-scope" width="sm:w-32" options={(scopes || []).map((s) => [s, s])} />
      <Input value={filters.workflow_id} onChange={(e) => onChange({ ...filters, workflow_id: e.target.value.trim() })} placeholder="Workflow / correlation id" className="h-8 text-xs font-mono-tech sm:w-64" data-testid="filter-workflow" />
      {active && <Button size="sm" variant="ghost" className="h-8 text-xs" onClick={() => onChange(EMPTY_FILTERS)} data-testid="filter-clear">Clear</Button>}
    </div>
  );
};
